import { isOfferExpired } from './offerStatus';

function parsePrice(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** Deal + original prices for one saved listing (snapshot at save time). */
export function getSavedDealLinePrices(product) {
  const dealPrice = parsePrice(product?.price);
  const rawOriginal = parsePrice(product?.originalPrice);
  const originalPrice = rawOriginal > dealPrice ? rawOriginal : dealPrice;
  const lineSaved = Math.max(0, originalPrice - dealPrice);
  return { dealPrice, originalPrice, lineSaved };
}

/**
 * Totals for active (non-expired) saved deals.
 * @param {Array} items
 * @returns {{ activeCount: number, originalTotal: number, dealTotal: number, savedTotal: number }}
 */
export function computeSavedDealsTotals(items = []) {
  let activeCount = 0;
  let originalTotal = 0;
  let dealTotal = 0;

  (items || []).forEach((product) => {
    if (isOfferExpired(product)) return;
    const { dealPrice, originalPrice } = getSavedDealLinePrices(product);
    if (dealPrice <= 0) return;
    activeCount += 1;
    dealTotal += dealPrice;
    originalTotal += originalPrice;
  });

  return {
    activeCount,
    originalTotal,
    dealTotal,
    savedTotal: Math.max(0, originalTotal - dealTotal),
  };
}
